<sh-tabs>
  <sh-tab-item
    label="{{ 'spareParts.serviceTickets' | translate }} {{ countDisplay() }}"
    [active]="serviceTicketsActive()"
    (click)="onServiceTicketsClick()"
    (keydown.enter)="activeTab.set(TAB_SERVICE_TICKETS)"
    (keydown.backspace)="activeTab.set(TAB_SERVICE_TICKETS)"
  >
  </sh-tab-item>
  <sh-tab-item
    label="{{ 'spareParts.serviceParts' | translate }}"
    [active]="servicePartsActive()"
    (click)="onServicePartsClick()"
    (keydown.enter)="activeTab.set(TAB_SERVICE_PARTS)"
    (keydown.backspace)="activeTab.set(TAB_SERVICE_PARTS)"
  >
  </sh-tab-item>
</sh-tabs>
